module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hqpAS"))).then(() => parcelRequire('2KbAe'));